import { render, staticRenderFns } from "./ModalLabelForm.vue?vue&type=template&id=a7a56d68&"
import script from "./ModalLabelForm.vue?vue&type=script&lang=js&"
export * from "./ModalLabelForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalLabelForm.vue?vue&type=style&index=0&id=a7a56d68&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports